import axios from "axios";
import permissions from "../../models/gestionEmpleados/empleados/permissions";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getPermissions() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = parseInt(localStorage.getItem("empId"), 10);

    return axios
      .get(`${url}/dcaempleadopermisos/${empId}`, { headers })
      .then(({ data }) => data.map((item) => permissions.fromJson(item)));
  }

  new(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      emps: data.emps,
      segmId: data.segmId,
      permisoId: data.permisoId,
      segmDespl: data.segmDespl,
      fecDesde: data.from + "T00:00:00.000Z",
    };
    if (data.hasOwnProperty("to")) {
      payload.fecHasta =
        moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.post(`${url}/dcapermisoempleados`, payload, { headers });
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/dcapermisoempleados/${data.empId}&${data.permisoId}&${data.fecDesde}`,
      {
        headers,
      }
    );
  }

  edit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = localStorage.getItem("empId");
    let payload = {
      legajo: data.legajo,
      empNombre: data.empNombre,
      segmDespl: data.initialDay,
      haNoEx: data.to == null ? true : false,
    };

    if (data.hasOwnProperty("segmId")) {
      payload.segmId = data.segmId;
      payload.segmNombre = data.segmNombre;
    }

    if (data.hasOwnProperty("from")) {
      payload.fecDesde = data.from + "T00:00:00.000Z";
    }

    if (data.hasOwnProperty("to")) {
      payload.fecHasta =
        moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios.patch(
      `${url}/dcapermisoempleados/${empId}&${data.permisoId}&${data.oldFrom}`,
      payload,
      { headers }
    );
  }
}
export default service;
